export default __webpack_public_path__ + "static/media/ETH.238235cc.png";